module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/icons/payment-icons/payment-icons.component.scss
// module id = ./src/app/icons/payment-icons/payment-icons.component.scss
// module chunks = main